"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAPIRegistry = exports.getRPCTypes = exports.getAPITypes = exports.createInterBtcApi = exports.createSubstrateAPI = exports.createProvider = void 0;
const api_1 = require("@polkadot/api");
const rpc_provider_1 = require("@polkadot/rpc-provider");
const types_1 = require("@polkadot/types");
const definitions = __importStar(require("./interfaces/definitions"));
const interbtc_api_1 = require("./interbtc-api");
function createProvider(endpoint, autoConnect) {
    if (/https?:\/\//.exec(endpoint)) {
        return new rpc_provider_1.HttpProvider(endpoint);
    }
    if (/wss?:\/\//.exec(endpoint)) {
        return new rpc_provider_1.WsProvider(endpoint, autoConnect);
    }
    throw new Error(`unknown scheme for ${endpoint}`);
}
exports.createProvider = createProvider;
function createSubstrateAPI(endpoint, autoConnect) {
    const provider = createProvider(endpoint, autoConnect);
    const types = getAPITypes();
    const rpc = getRPCTypes();
    return api_1.ApiPromise.create({ provider, types, rpc });
}
exports.createSubstrateAPI = createSubstrateAPI;
function createInterBtcApi(endpoint, network = "mainnet", account, autoConnect) {
    return __awaiter(this, void 0, void 0, function* () {
        const api = yield createSubstrateAPI(endpoint, autoConnect);
        return new interbtc_api_1.DefaultInterBtcApi(api, network, account);
    });
}
exports.createInterBtcApi = createInterBtcApi;
function getAPITypes() {
    return Object.values(definitions).reduce((res, { types }) => (Object.assign(Object.assign({}, res), types)), {});
}
exports.getAPITypes = getAPITypes;
function getRPCTypes() {
    return Object.values(definitions).reduce((res, { providerRpc }) => (Object.assign(Object.assign({}, res), providerRpc)), {});
}
exports.getRPCTypes = getRPCTypes;
function createAPIRegistry() {
    const registry = new types_1.TypeRegistry();
    registry.register(getAPITypes());
    return registry;
}
exports.createAPIRegistry = createAPIRegistry;
//# sourceMappingURL=factory.js.map